module.exports = __webpack_public_path__ + "img/plan-finished.2ea2aa7f.png";